import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, ProtectedRoute } from "@/context/AuthContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import ItemPage from "@/pages/ItemPage";
import PrintPage from "@/pages/PrintPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SelectionPage from "@/pages/SelectionPage";
import { ShortlistProvider } from "@/context/ShortlistContext";
import { CompareProvider } from "@/context/CompareContext";
import { CompareTray } from "@/components/Compare";
import ComparePage from "@/pages/ComparePage";
import PairingPage from "@/pages/PairingPage";
import PairPrintPage from "@/pages/PairPrintPage";

const PublicLayout = () => (
  <>
    <Nav />
    <Outlet />
    <Footer />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
      <ShortlistProvider>
      <CompareProvider>
        <SmoothScroll />
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/c/:slug" element={<CategoryPage />} />
            <Route path="/item/:id" element={<ItemPage />} />
            <Route path="/selection" element={<SelectionPage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/pairing" element={<PairingPage />} />
          </Route>
          <Route path="/print" element={<PrintPage />} />
          <Route path="/pairing/print" element={<PairPrintPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        </Routes>
        <CompareTray />
        <Toaster theme="dark" position="bottom-right" />
      </CompareProvider>
      </ShortlistProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
